import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const FIRESTORE_DATABASE_ID = "vortx-flux-site-dna";

// Auth config — ALWAYS prod project (shared user accounts)
const authConfig = {
    apiKey: "AIzaSyAzP4QIB_NZ62l01mUkPxbaqeCbRGVNfl8",
    authDomain: "vortx-flux-site-dna-389f0.firebaseapp.com",
    projectId: "vortx-flux-site-dna-389f0",
    storageBucket: "vortx-flux-site-dna-389f0.firebasestorage.app",
    messagingSenderId: "202472576296",
    appId: "1:202472576296:web:eafe87f23094dc9ad36c1d",
    measurementId: "G-XWQQ1ENSQL"
};

// Firestore project — env-dependent (prod by default)
const firestoreProject = process.env.REACT_APP_FIREBASE_PROJECT || authConfig.projectId;
const firestoreApiKey = process.env.REACT_APP_FIREBASE_API_KEY || authConfig.apiKey;
const isSameProject = firestoreProject === authConfig.projectId;

// Auth app (always prod)
const authApp = initializeApp(authConfig, isSameProject ? undefined : 'auth');

// Firestore app (env-dependent)
let dbApp;
if (isSameProject) {
    dbApp = authApp;
} else {
    dbApp = initializeApp({
        apiKey: firestoreApiKey,
        projectId: firestoreProject,
    }, 'db');
}

export const auth = getAuth(authApp);
export const db = getFirestore(dbApp, FIRESTORE_DATABASE_ID);

export const authReady = setPersistence(auth, browserLocalPersistence)
    .then(() => {
        console.log("[Firebase] Auth persistence enabled (local storage)");
        if (!isSameProject) {
            console.log(`[Firebase] Firestore -> ${firestoreProject} (dev)`);
        }
    })
    .catch((error) => {
        console.error("[Firebase] Failed to set persistence:", error);
    });

export const analytics = isSameProject ? getAnalytics(authApp) : null;
